<template>
  <div class="content-body">
    <div class="container-fluid">
    <Breadcrumb name="Request Money" :breadcrumb="breadcrumb" />
      <!-- row -->
      <div class="row">
        <div class="col-xl-12 col-xxl-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Details</h4>
            </div>
            <div class="card-body">
              <div class="basic-form">
                <Form @submit="sendCall">
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Email Address or Phone</label>
                    <div class="col-sm-9">
                      <Field
                          class="form-control"
                          type="text"
                          name="emailOrPhone"
                          rules="required"
                      />
                      <ErrorMessage name="emailOrPhone"/>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Amount</label>
                    <div class="col-sm-9">
                      <Field
                          class="form-control"
                          type="text"
                          name="amount"
                          rules="required|numeric"
                      />
                      <ErrorMessage name="amount"/>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Wallet</label>
                    <div class="col-sm-9">
                      <select class="form-control" v-model="selectedValet" name="userAccountId">
                        <option :key="valetIndex" :value="valet.id" v-for="(valet, valetIndex) in valetData">
                          {{ valet.currency.code }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Notes</label>
                    <div class="col-sm-9">
                      <Field
                          class="form-control"
                          name="notes"
                          as="textarea"
                          rows="3"
                          placeholder="Type Your Notes Here........"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-10">
                      <Button class="btn btn-primary" :loading="loader" >Send</Button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    setTimeout(() => {

      this.getValetData()
    }, 1000);

  },
  data() {
    return {
      loader: false,
      emailOrPhone: '',
      selectedValet: null,
      valetData: [],
      breadcrumb:[
        {name: 'App'},
        {name: 'Request Money'}
      ],

    }
  },
  methods: {
    sendCall(values) {
      values.userAccountId = this.selectedValet;
      values.amount = values.amount*100
      let data = values
      this.loader = true
      this.makeRequest('post', 'v1/initiate-request-money', data).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.$router.push({name: 'request-money'});
          }
          else if (code == 401) {
            this.$router.push({name: 'send-otp'});
          }
        }

      });

    },
    getValetData() {
      this.makeRequest('post', 'v1/get-wallet-list', {}, {}, false).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          let responseData = callResponse.response.data.data
          if (code == 200) {
            this.valetData = responseData
            this.setSelectValetValue()
          }
        }

      });
    },
    setSelectValetValue() {
      this.valetData.forEach((obj) => {
        if (obj.is_default == 1) {
          this.selectedValet = obj.id
        }
      })

    }
  },
}
</script>

